import type { RootState } from 'store'

export const getHeaderMenus = (state: RootState) => state.menus.header

export const getFooterMenus = (state: RootState) => state.menus.footer
